import React from 'react';
import {Outlet, useLocation} from "react-router-dom";
import ClientProjectProvider, {ProjectContext} from "../../providers/ClientProjectProvider";
import {Helmet} from "react-helmet";

const ProjectLayout = () => {
    //TODO check auth permissions
    const {pathname} = useLocation();

    const projectPageTitle = (projectName) => {
        if (pathname.includes('talent-pool')) {
            return `Find Talent for ${projectName}`
        }else if (pathname.includes('shortlist')) {
            return `Shortlist for ${projectName}`
        }else if (pathname.includes('brief')) {
            return `Brief for ${projectName}`
        }else if (pathname.includes('contract')) {
            return `SOW for ${projectName} `
        }else if (pathname.includes('active')) {
            return `Active - ${projectName}`
        }
        return projectName
    }

    return (
        <ClientProjectProvider>
            <ProjectContext.Consumer>
                {({project}) => (project?.name ? (
                    <Helmet>
                        <title>{projectPageTitle(project.name)} | Wripple</title>
                    </Helmet>
                ) : undefined)}
            </ProjectContext.Consumer>
            <Outlet/>
        </ClientProjectProvider>
    );
};

export default ProjectLayout;